import React from "react";
import Picture from "../assets/Picture.png";
import line from "../assets/line.png";
import Integrated from "../assets/Integrated.png";
import First from "../assets/First.jpg";
import ServicesSection from "../pages/ServicesSection"; 
import { motion } from 'framer-motion';
import ColourLogo from "../assets/ColourLogo.svg";
import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";

 
const service = () => {
  return (
    <div className="min-h-screen scroll-smooth">
      {/* Hero Section with Video Background for Services */}
      <section className="relative h-[50vh] sm:h-[60vh] flex items-center justify-center text-white overflow-hidden">
        {/* 🎥 Video Background */}
        <video
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
          src="/Services780.mp4"
          autoPlay
          muted
          loop
          playsInline
        />

        {/* 🌫️ Transparent Overlay */}
       <div className="absolute inset-0 bg-gradient-to-r from-[#0A1B60] via-[#1F2E8A] to-[#4B0FA3] opacity-40 z-10" />


        {/* 📝 Foreground Text */}
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 w-full z-20 flex flex-col items-center text-center">
         <motion.h1
      className="text-3xl sm:text-5xl md:text-7xl text-white font-bold uppercase"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, ease: 'easeOut' }}
    >
      AI‑POWERED SERVICES
    </motion.h1>

    {/* Stylish Subheading Animation */}
   <motion.h2
  className="uppercase whitespace-nowrap font-extrabold text-transparent mt-4"
  style={{
    fontFamily: 'Calibri, sans-serif',
    WebkitTextStroke: '2px #ffffff',
    fontSize: '3rem', // increased from 2rem
    lineHeight: 1.2,
    letterSpacing: '0.05em',
  }}
  initial={{ opacity: 0, x: -100 }}
  animate={{ opacity: 1, x: 0 }}
  transition={{ duration: 1.2, ease: 'easeOut' }}
>
  <span className="hidden sm:inline">Reimagining Care and Insights</span>
</motion.h2>


        </div>
      </section>

      {/* Vision Section */}
      <section className="pt-20 sm:pt-[160px] pb-12 sm:pb-[100px] px-4 sm:px-6 bg-white flex flex-col items-center justify-center text-center md:text-left snap-start w-full !h-auto">
        <div className="max-w-6xl w-full mx-auto flex flex-col items-center text-gray-900 text-sm sm:text-base md:text-lg lg:text-xl font-normal leading-relaxed space-y-6 sm:space-y-10">
          <p className="max-w-4xl text-center px-2 sm:px-4">
            WISE offers a suite of platform-based products designed to revolutionize Healthcare,
            Lifesciences and other domains. From hospital management to lab automation and patient
            care, our AI-driven solutions provide seamless integration, enhanced efficiency, and
            data-driven decision-making.
          </p>

          {/* Product Offerings */}
          <div className="w-full">
            <ServicesSection />
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className=" bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6] text-white flex items-center justify-center snap-start w-full !h-auto py-16 sm:py-[120px] px-4">
        <div className="max-w-6xl w-full flex flex-col">
          {/* Heading */}
          <div className="relative inline-block mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold">
              Benefits of <span style={{ color: "#0077cc" }}>Wise</span> Services
            </h2>
            <img
              src={line}
              alt="underline"
              className="absolute left-0 -bottom-2 h-[4px] sm:h-[6px] object-contain"
            />
          </div>

          {/* Functionality Points */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 w-full max-w-4xl">
            {/* Left Column */}
            <ul className="space-y-4 sm:space-y-6 list-disc list-inside marker:text-blue-400 text-base sm:text-lg md:text-xl leading-relaxed">
              {['AI-Led Precision', 'Deep Domain Expertise', 'Faster Turnaround'].map((item, index) => (
                <li
                  key={index}
                  className="font-medium transition-transform duration-300 hover:translate-x-2"
                >
                  {item}
                </li>
              ))}
            </ul>

            {/* Right Column */}
            <ul className="space-y-4 sm:space-y-6 list-disc list-inside marker:text-blue-400 text-base sm:text-lg md:text-xl leading-relaxed">
              {['Scalable & Flexible', 'Compliance & Security First', 'Actionable Insights'].map((item, index) => (
                <li
                  key={index}
                  className="font-medium transition-transform duration-300 hover:translate-x-2"
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
  <section className="relative bg-gradient-to-r from-[#050A3A] via-[#1A0F6B] to-[#3E0E9F] overflow-hidden">
  {/* White curved part */}
  <div className="absolute top-[180px] left-0 w-full">
    <div className="bg-white rounded-t-[12rem] sm:rounded-t-[14rem] h-[120vh]"></div>
  </div>

  {/* Content */}
  <div className="relative z-10 px-6 sm:px-10 md:px-16 lg:px-24 pt-24 pb-16">
    {/* Top heading part */}
    <div className="text-center mt-[160px] mb-12">
     <h2
  className="text-4xl sm:text-5xl font-bold mb-2 text-[#6F7DFF]"
>
  Collaborate for Success
</h2>
      <p className="text-gray-700 text-lg sm:text-xl font-medium">
        Working together with others fosters innovation, creativity, and a greater sense of accomplishment.
      </p>
    </div>

    {/* Four-column footer part */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-gray-800">
      {/* About Us */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">ABOUT US</h3>
        <img src={ColourLogo} alt="Wissenstil Solutions" className="w-40 mb-4" />
      <p className="mb-4 leading-relaxed">
  Wissenstil Solutions is a specialized software company driving digital innovation.
</p>
      </div>

      {/* Services */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">SERVICES</h3>
        <ul className="space-y-2">
          <li>Image Analysis</li>
          <li>Anomaly Detection</li>
          <li>Medical Coding</li>
        </ul>
      </div>

  
{/* Useful Links */}
<div>
  <h3 className="font-bold mb-4 text-gray-900">USEFUL LINKS</h3>
  <ul
    className="space-y-2 text-gray-800"
    style={{ fontFamily: 'Calibri, sans-serif' }}
  >
    {[
      { name: "About Us", path: "/about" },
      { name: "Wise Services", path: "/services" },
      { name: "Wise Products", path: "/products" },
      { name: "Contact Us", path: "/contact" },
    ].map((link, index) => (
      <li
        key={index}
        className="transition-transform duration-300 hover:translate-x-2 text-base sm:text-lg md:text-xl"
      >
        <Link
          to={link.path}
          onClick={() => (window.location.href = link.path)}
          className="relative inline-block hover:text-purple-700 transition-colors duration-200 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:bg-purple-700 hover:after:w-full after:transition-all after:duration-300"
        >
          {link.name}
        </Link>
      </li>
    ))}
  </ul>
</div>

      {/* Contact */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">CONTACT US</h3>
        <p>
          Wissenstil Solutions Private Ltd.<br />
          Brigade IRV Centre, 09th &amp; 10th Floor,<br />
          Nallurahalli, Whitefield,<br />
          Bangalore, 560066.
        </p>
     

<div className="mt-4 space-y-3 text-white">
  <p className="flex items-center space-x-3">
    <Phone className="w-5 h-5 text-gray-900" />
    <span className="text-gray-900 font-medium">+91 9986158307</span>
  </p>
  <p className="flex items-center space-x-3">
    <Mail className="w-5 h-5 text-gray-900" />
    <span className="text-gray-900 font-medium">Manish.palliyil@wissenstil.com</span>
  </p>
</div>
      </div>
    </div>
  </div>
</section>

    </div>
  );
};
 
export default service;
